module.exports = __webpack_public_path__ + "img/race_25.6c3221a8.png";